import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ProjectActionTypes } from '../../redux/project/project.types';
import { DefinitionsActionTypes } from '../../redux/definitions/definitions.types';
import { SocialIcon } from 'react-social-icons';
import Select, { components } from "react-select";
import Popup from 'reactjs-popup';
import PhoneInput from 'react-phone-number-input/input';
import 'reactjs-popup/dist/index.css';

import CheckBox from '../../components/checkbox/checkbox.component';
import Button from '../../components/button/button.component';
import { showWarningLayer } from '../../utils/utils';
import './step5.styles.scss';
//import 'react-phone-number-input/style.css';

class Step5 extends React.Component{
  constructor(props){
    super(props);
    this.scrollRef = React.createRef()  
    this.state = {
      showInfo:(this.props.step5.showInfo !== undefined && this.props.step5.showInfo === true) ? true : false,
      disablePhone:(this.props.step5.phone !== undefined && this.props.step5.phone.length > 0) ? false : true,
      disableEmail:(this.props.step5.email !== undefined && this.props.step5.email.length > 0) ? false : true,
      socialLink:'',
      iletisimTercihleri: (this.props.step5.iletisimTercihleri === null || this.props.step5.iletisimTercihleri === undefined || this.props.step5.iletisimTercihleri === []) ? [] : this.props.step5.iletisimTercihleri, 
      gizliTercihler: (this.props.step5.gizliTercihler === null || this.props.step5.gizliTercihler === undefined || this.props.step5.gizliTercihler === []) ? [] : this.props.step5.gizliTercihler, 
      socials: (this.props.step5.socials === null || this.props.step5.socials === undefined || this.props.step5.socials === []) ? [] : this.props.step5.socials,
      socialPrefix:'https://www.facebook.com/',
      formOpen: false
    };

    if (this.props.step5.gizliTercihler === null || this.props.step5.gizliTercihler === undefined){
      this.props.setStep5({
        ...this.props.step5,
        gizliTercihler: []
      });    
    }

    if (this.props.step5.iletisimTercihleri === null || this.props.step5.iletisimTercihleri === undefined){
      this.props.setStep5({
        ...this.props.step5,
        iletisimTercihleri: []
      });    
    }

    this.handleSocialLinkChange = this.handleSocialLinkChange.bind(this);
    this.addToSocials = this.addToSocials.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleIletisimTercihleri = this.handleIletisimTercihleri.bind(this);
    this.handleGizliTercihler = this.handleGizliTercihler.bind(this);
    this.handleTableTicks = this.handleTableTicks.bind(this);
    this.handleGizliPhoneChange = this.handleGizliPhoneChange.bind(this);
    this.handleGizliEmailChange = this.handleGizliEmailChange.bind(this);
    this.handleScrollToElement = this.handleScrollToElement.bind(this);

    this.options = [
      { custom: true, typex:"facebook", link:"https://www.facebook.com/", label:"Facebook", value:"facebook" },
      { custom: true, typex:"twitter", link:"https://twitter.com/",label:"Twitter", value:"twitter"  },
      { custom: true, typex:"instagram", link:"https://www.instagram.com/", label:"Instagram", value:"instagram"  },
      { custom: true, typex:"linkedin", link:"https://www.linkedin.com/in/", label:"LinkedIn", value:"linkedin"  },
      { custom: true, typex:"youtube", link:"https://www.youtube.com/channel/", label:"YouTube", value:"youtube"  }
    ];      

  }

  UNSAFE_componentWillMount(){
    this.props.setStep5({
      ...this.props.step5,
      rizaMetni: false
    }); 

  }

  handleScrollToElement(event) {
    this.scrollRef.current.scrollTo(0,0);
  }


  // handlePhoneChange(event){
  //   this.props.setStep5({
  //     ...this.props.step5,
  //     phone:event.target.value
  //   })    
  // }

  handlePhoneChange(value){
    this.props.setStep5({
      ...this.props.step5,
      phone:value
    })    
  }  

  handleEmailChange(event){
    this.props.setStep5({
      ...this.props.step5,
      email:event.target.value
    })    
  }

  // handleGizliPhoneChange(event){
  //   this.props.setStep5({
  //     ...this.props.step5,
  //     gizliphone:event.target.value
  //   })    
  // }  
  handleGizliPhoneChange(value){
    this.props.setStep5({
      ...this.props.step5,
      gizliphone:value
    })    
  }


  handleGizliEmailChange(event){
    this.props.setStep5({
      ...this.props.step5,
      gizliemail:event.target.value
    })    
  }    

  handleIsContactShow = (val) => {
    let tmpCheck = false;
    if (val === "1"){
      tmpCheck = true;
    }
    this.setState(()=>({
      ...this.state,
      showInfo: tmpCheck
    }));

    this.props.setStep5({
      ...this.props.step5,
      showInfo: tmpCheck
    });         

  }  

  handleCheck = (target) => {
    let tmpCheck = true;
    if (target.checked === true){
      tmpCheck = false;
    }
    
    if (target.name === "contactPhone"){
      this.setState(()=>({
        ...this.state,
        disablePhone: tmpCheck
      }));

      this.props.setStep5({
        ...this.props.step5,
        disablePhone: tmpCheck
      });      

      if (tmpCheck === false){
        setTimeout(()=> {
          this.phoneInput.focus();
        },50);
        
      }
  
    }else if (target.name === "contactEmail"){
      this.setState(()=>({
        ...this.state,
        disableEmail: tmpCheck
      }));

      this.props.setStep5({
        ...this.props.step5,
        disableEmail: tmpCheck
      });          

      if (tmpCheck === false){
        setTimeout(()=> {
          this.emailInput.focus();
        },50);        
      }
    }
  }  

  handleIletisimTercihleri = changeEvent => {
    const { name } = changeEvent.target;
    const newArray = this.state.iletisimTercihleri.slice();    
    
    if (changeEvent.target.checked === true){
      if (newArray.indexOf(name) === -1) {
        newArray.push(name);
      }    
      this.setState({
        ...this.state,
        iletisimTercihleri: newArray,
      });
  
      this.props.setStep5({
        ...this.props.step5,
        iletisimTercihleri:newArray
      })    

    }else{
      const newList = [...this.state.iletisimTercihleri];
      var tmpIndex = newList.indexOf(name);
      if (tmpIndex !== -1){
        newList.splice(tmpIndex,1);
        this.setState({
          ...this.state,
          iletisimTercihleri: newList
        })
        this.props.setStep5({
          ...this.props.step5,
          iletisimTercihleri:newList,
        })      
      }
    }
    
  };

  handleTableTicks = changeEvent => {
    const { name } = changeEvent.target;
    
    if (changeEvent.target.checked === true){
      this.setState({
        ...this.state,
        [name]:true
      });
  
      this.props.setStep5({
        ...this.props.step5,
        [name]:true
      })    

    }else{
      this.setState({
        ...this.state,
        [name]:false
      });
  
      this.props.setStep5({
        ...this.props.step5,
        [name]:false
      })  
    }
    
  };

  
  CustomOption = props => {
    const { data, innerRef, innerProps } = props;
    return data.custom ? (
      <div className="socialSelectWrapper" ref={innerRef} {...innerProps}>
        <SocialIcon className="socialMediaIcon" network={data.typex} style={{ height: 30, width: 30 }}  /> 
      </div>
    ) : (
      <components.Option {...props} />
    );
  };  

  formatOptionLabel = ({ typex }) => (
    <SocialIcon network={typex} className="socialMediaIcon" style={{ height: 30, width: 30 }} />
  );  
  
  handleGizliTercihler = changeEvent => {
    const { name } = changeEvent.target;
    const newArray = this.state.gizliTercihler.slice();    

    if (changeEvent.target.checked === true){
      if (newArray.indexOf(name) === -1) {
        newArray.push(name);
      }    
      this.setState({
        ...this.state,
        gizliTercihler: newArray,
        [name]: true
      });
  
      this.props.setStep5({
        ...this.props.step5,
        gizliTercihler:newArray,
        [name]: true
      })    

    }else{
      const newList = [...this.state.gizliTercihler];
      var tmpIndex = newList.indexOf(name);
      if (tmpIndex !== -1){
        newList.splice(tmpIndex,1);
        this.setState({
          ...this.state,
          gizliTercihler: newList,
          [name]: false
        })
        this.props.setStep5({
          ...this.props.step5,
          gizliTercihler:newList,
          [name]: false
        })      
  
      }
  
    }

    

    
    
  };   

  handleGizliEmailCheck = changeEvent => {
    if (changeEvent.target.checked === true){
      this.props.setStep5({
        ...this.props.step5,
        gizliemailcheck:true
      })    
    }else{
        this.props.setStep5({
          ...this.props.step5,
          gizliemailcheck:false
        })      
    }
  };   

  

  handleSocialLinkChange(event){
    this.setState({
      ...this.state,
      socialLink: event.target.value
    })
  }

  addToSocials(){
    let newLink = this.state.socialLink;
    if (newLink.length < 2){
      const warnmessage = "Lütfen geçerli bir bağlantı adresi girin.";
      this.props.onWarning({warningMessageType:'fail', warningMessageText: warnmessage});      
      showWarningLayer();
      return;
    }

    newLink = this.state.socialPrefix + newLink;

    const newArray = this.state.socials.slice();  
    if (newArray.indexOf(newLink) === -1) {
      newArray.push(newLink);
    }

    this.setState({
      ...this.state,
      socials: newArray,
      socialLink:''
    });

    this.props.setStep5({
      ...this.props.step5,
      socials:newArray
    });      
  }

  removeItem(item,index){
    const newList = [...this.state.socials];
    var tmpIndex = newList.indexOf(item);
    if (tmpIndex !== -1){
      newList.splice(index,1);
      this.setState({
        ...this.state,
        socials: newList
      })
      this.props.setStep5({
        ...this.props.step5,
        socials:newList,
      })      

    }
  }

  handleRizaMetni = (event) => {
    let tmpCheck = false;
    if (event.target.checked === true){
      tmpCheck = true;
    }
    this.props.setStep5({
      ...this.props.step5,
      rizaMetni: tmpCheck
    }); 
  }    

  handleSocialChange = (event) => {
    this.setState({
      ...this.state,
      socialPrefix: event.link
    });    
  }


  setOpen = (val) =>{
    this.setState({
      ...this.state,
      formOpen: val
    })
  }


  closeModal = () => {
    this.setOpen(false)
  }


  componentDidMount(){
    this.props.setCurrent('step-5');
  }   
  render(){
    return(
      <section className="mainSection">
        <div className="sectionWrapper">
          <div className="gridWrapper gridWrapperStep5">
            <div>
              <h4 className="sectionTitle">Sosyal Medya Hesaplarınız</h4>
              <div className="baglantiWrapper">
                <Select 
                  className="socialSelect"
                  placeholder=""
                  defaultValue={{custom: true, typex:"facebook", link:"https://www.facebook.com/", label:"Facebook", value:"facebook"}}
                  formatOptionLabel={this.formatOptionLabel}
                  components={{ Option: this.CustomOption }}
                  options={this.options} 
                  isSearchable={false}
                  color="#ff004c"
                  onChange={this.handleSocialChange}


                />              
                <input type="text" placeholder="Hesap adı" className="edits" value={this.state.socialLink} onChange={this.handleSocialLinkChange} />
                <Button onClick={this.addToSocials}>Ekle</Button>
              </div>
              <div className="componentWrapper step5-layer1">
                <div className="contentInfoWrapper gorus-konular step5SosyalMedya">
                  <ul className="ulSosyalHesaplar">
                  {
                    this.state.socials.map((item,index)=>(
                      <li key={index} title={item}><button className="btn-remove-list" onClick={() => this.removeItem(item,index)} ></button><div className="socialLine"><SocialIcon className="socialMediaIcon" style={{ height: 30, width: 30 }} url={item} /> <span className="socialMedyaInfo">{item}</span></div> </li>
                    ))
                  }
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <div className="medyaDeneyimiRadioGroupWrapper">
                <div name="medyaDeneyimi" className="medyaDeneyimiRadioGroup">
                  <div value="0" name="iletisimBilgileri" className="iletisimBilgileriCheckGroupPres">
                    <div className="formBox0">
                      <h4 className="sectionTitle">İletişim Bilgileriniz</h4>                  
                    </div>
                    <div className="formBox1">
                      <h5>Profilimde Görünsün</h5>
                    </div>
                    <div className="formBox2">
                      <h5>İletişim İçin Kullanılsın</h5>
                    </div>
                    <div className="formBox3">
                      <label>Telefon :</label>
                    </div>
                    <div className="formBox4">
                    <PhoneInput
                      //ref={(input) => { this.phoneInput = input; }}
                      placeholder="Telefon numaranızı giriniz"
                      value={this.props.step5.phone}
                      onChange={this.handlePhoneChange}
                      className="edits"
                      defaultCountry="TR"
                     
                      
                      
                    />                    
                      {
                        // <input type="text" ref={(input) => { this.phoneInput = input; }} placeholder="Telefon numaranızı giriniz" className="edits" value={this.props.step5.phone} onChange={this.handlePhoneChange} />
                      }
                    </div>                  
                    <div className="formBox5">
                      <CheckBox value="" className="contactCheck" name="tercihphoneshow" checked={ (this.props.step5.tercihphoneshow === undefined || this.props.step5.tercihphoneshow === null) ? false : this.props.step5.tercihphoneshow} defaultCheck={false}  onChange={this.handleTableTicks}></CheckBox> 
                    </div>                  
                    <div className="formBox6">
                      <CheckBox value="" className="contactCheck" name="tercihphoneuse" checked={ (this.props.step5.tercihphoneuse === undefined || this.props.step5.tercihphoneuse === null) ? false : this.props.step5.tercihphoneuse} defaultCheck={false} onChange={this.handleTableTicks}></CheckBox> 
                    </div>                  
                    <div className="formBox7">
                      <label>E-posta :</label>
                    </div>                  
                    <div className="formBox8">
                      <input type="text" ref={(input) => { this.emailInput = input; }} placeholder="E-Posta adresinizi giriniz" className="edits" value={this.props.step5.email} onChange={this.handleEmailChange} />
                    </div>                  
                    <div className="formBox9">
                      <CheckBox value="" className="contactCheck" name="tercihemailshow" checked={ (this.props.step5.tercihemailshow === undefined || this.props.step5.tercihemailshow === null) ? false : this.props.step5.tercihemailshow } defaultCheck={false} onChange={this.handleTableTicks}></CheckBox> 
                    </div>                  
                    <div className="formBox10">
                      <CheckBox value="" className="contactCheck" name="tercihemailuse" checked={ (this.props.step5.tercihemailuse === undefined || this.props.step5.tercihemailuse === null) ? false : this.props.step5.tercihemailuse } defaultCheck={false}  onChange={this.handleTableTicks}></CheckBox> 
                    </div>                                

                  </div>                     
                </div>  
                
                
                
              </div>

               
                  <p className="infoAltyapi">
                    Size telefon numaranız ve e-posta adresiniz sitede gözükmeden ulaşılabilecek bir alt yapımız mevcut.Bunun için aşağıdaki tercihlerden birini seçiniz.
                    <span className="altyapiSub">
                      Size ulaşmak isteyen medya çalışanı telefon numaranızı görmeden sizi arayabilecek veya sms veya whatsapp gönderebilecek, e-mailler ise yine bizim platformumuz üzerinden sizin e-maillerinize düşecek. Doldurduğunuz formun iletişim bilgileri, sitede arama yapanlar tarafından görünmeyecek                    
                    </span>
                  </p>
                  <div className="contactWrapper groupContacts">
                  <div value="0" name="iletisimBilgileri" className="iletisimBilgileriCheckGroup">
                    <CheckBox value="1" name="gizlitercihsms" checked={(this.props.step5.gizlitercihsms === null || this.props.step5.gizlitercihsms === undefined ) ? false : this.props.step5.gizlitercihsms} defaultCheck={false }  onChange={this.handleGizliTercihler} >Sms</CheckBox>
                    <CheckBox value="2" name="gizliterciharama" checked={(this.props.step5.gizliterciharama === null || this.props.step5.gizliterciharama === undefined ) ? false : this.props.step5.gizliterciharama} defaultCheck={false }   onChange={this.handleGizliTercihler} >Arama</CheckBox>
                    <CheckBox value="3" name="gizlitercihwhatsapp" checked={(this.props.step5.gizlitercihwhatsapp === null || this.props.step5.gizlitercihwhatsapp === undefined ) ? false : this.props.step5.gizlitercihwhatsapp} defaultCheck={false }  onChange={this.handleGizliTercihler} >WhatsApp</CheckBox>
                  </div> 
                  <PhoneInput
                  //ref={(input) => { this.phoneInput = input; }}
                    placeholder="Telefon numaranızı giriniz"
                    value={this.props.step5.gizliphone}
                    onChange={this.handleGizliPhoneChange}
                    disabled={ this.props.step5.gizliTercihler !== undefined && this.props.step5.gizliTercihler.length > 0 ? false : true }
                    className="edits"
                    defaultCountry="TR"
                  /> 
                  {
                  // <input type="text" placeholder="Telefon numaranızı giriniz" className="edits" disabled={ this.props.step5.gizliTercihler !== undefined && this.props.step5.gizliTercihler.length > 0 ? false : true } onChange={this.handleGizliPhoneChange} value={this.props.step5.gizliphone}  />
                  } 
                  </div>
                  <div className="contactWrapper groupContacts2">
                    <CheckBox value="" className="contactCheck" checked={this.props.step5.gizliemailcheck} onChange={this.handleGizliEmailCheck}  name="contactEmail" defaultCheck={false}>E-posta :</CheckBox> <input type="text" placeholder="E-Posta adresinizi giriniz" className="edits" disabled={this.props.step5.gizliemailcheck === true ? false : true} onChange={this.handleGizliEmailChange} value={this.props.step5.gizliemail} />
                  </div>              


              <div className="margin-top-x">
                <CheckBox value="rizametni" className="onayTick" defaultCheck={false} onChange={this.handleRizaMetni}><span className="on-bilgilendirme-formu-text" onClick={() => this.setOpen(true)}><u>Aydınlatma Metni ve Ön Bilgilendirme Formu</u></span>'nu okudum onaylıyorum.</CheckBox>
              </div>



            </div>

          </div>
        </div>
      
      <Popup open={this.state.formOpen} closeOnDocumentClick onClose={this.closeModal} onOpen={this.handleScrollToElement} position="top center">
        <button className="fixclose" onClick={this.closeModal}><img src="/assets/images/close-button.png" alt="" className="closeButton" /></button>
        <div ref={this.scrollRef} className="modal modalForm">
          <div className="modalWrapper">
            <p className="textCenter"><strong>SENSİZ OLMAZ, SESSİZ OLMAZ PROJESİ KAPSAMINDA</strong></p>
            <p className="textCenter"><strong>KİŞİSEL VERİLERİN İŞLENMESİ VE GÜVENLİĞİNE İLİŞKİN</strong></p>
            <p className="textCenter"><strong>AÇIK RIZA ONAY FORMU</strong></p>
            <p><strong>&nbsp;</strong></p>
            { /*<p>Ekteki detaylı aydınlatma metni ve onay formunu okumanızı ve onaylamanızı rica ediyoruz. Metin, siteye kaydettiğiniz kişisel verilerinizi site kullanım amacı ve ilgili yasanın gerektirdiği haller haricinde hiçbir şekilde başka bir merci, kurum veya kişi ile paylaşmayacağımızı belirtiyor.</p> */}
            <p><i>Par Araştırma ve Danışmanlık Anonim Şirketi tarafından yürütülen "Sensiz olmaz, Sessiz olmaz" Projesi </i> ve Portal'ı kapsamında veri sahibince düzenlenen Kişisel verilen işlenmesine ilişkin aydınlatma metnini (<a rel="noreferrer" href="https://www.sensizolmazsessizolmaz.org/soso-aydinlatma-metni.pdf" target="_blank" >www.sensizolmazsessizolmaz.org/soso-aydinlatma-metni.pdf</a>) okuduğumu, anladığımı bu metinde yer alan kişisel verilerimin (özel nitelikli kişisel verilerim dahil)  işlenme amaçları, yurt içinde ve yurt dışında aktarıldığı kurum, kuruluş, 3. Kişiler ile  toplanma yöntemleri ve hukuki sebepleri, kişisel verilerimin korunmasına yönelik haklarım, veri güvenliği ve başvuru hakkıma dair bilgilendirildiğimi, Kişisel verilerimin ve Özel Nitelikli Kişisel Verilerimin veri sorumlusu sıfatıyla Par Araştırma ve Danışmanlık Anonim Şirketi veya gerekli güvenlik tedbirlerini aldırmak suretiyle yetkilendirdiği veri işleyenler tarafından; faaliyeti kapsamında tabii olduğu tüm mevzuatlar gereği yükümlülüklerini yerine getirmek, faaliyeti kapsamındaki hizmetlerinin verilebilmesi için akdedilen hizmetlere konu sözleşmelerin koşullarının ifası ve üstlenilen yükümlülükleri yerine getirebilmek, veri sahibi hakkında değerlendirmelerin  yapılması, istihbarat, bilgi araştırmaları, planlama, istatistiki çalışmaların yapılabilmesi, veri sahibinin geçmişi, istatistiki verileri, vb. ile ilgili verilerini analiz etmesi sırasında  hizmetlerin en iyi şekilde sunulabilmesi için kullanmak sureti ile geliştirilmesi; veri sahibine  sunulan  hizmetlerinin güncel durumu ve güncellemeler ile ilgili veri sahibi ile iletişime geçilebilmesi, bu hususta gerekli bilgilendirmelerin yapılabilmesi, anlaşmalı kurumları ve çözüm ortakları tarafından veri sahibine öneri sunabilmek, hizmetlerimizle ilgili bilgilendirebilmek, hizmetlerimiz ile ilgili şikayet ve önerilerini değerlendirebilmek, yasal yükümlülüklerimizi yerine getirebilmek ve yürürlükteki mevzuattan doğan haklarımızı kullanabilmek, <strong>Portal</strong> tarafından sunulan hizmetlerin üyelerin araştırmalarına ve ihtiyaçlarına göre özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması için gerekli olan aktivitelerin planlanması ve icrası, <strong>Portal</strong> tarafından sunulan hizmetlerin üyelerin araştırmalarına ve ihtiyaçlarına göre özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması, <strong>Portal</strong> tarafından sunulan hizmetlerden üyeleri faydalandırmak için gerekli çalışmaların proje birimleri tarafından yapılması ve ilgili süreçlerinin yürütülmesi, <strong>Portal</strong> tarafından yürütülen faaliyetlerin gerçekleştirilmesi için ilgili proje birimleri tarafından gerekli çalışmaların yapılması ve buna bağlı süreçlerinin yürütülmesi, <strong>Portal</strong>‘ın  bağlı olduğu Sensiz Olmaz Sessiz Olmaz projesi kapsamında stratejilerinin planlanması, geliştirilmesi ve icrası, <strong>Portal</strong>‘ın ve <strong>Portal</strong>‘la ilişki içerisinde olan kişilerin, hukuki ve teknik güvenliğinin temini, toplu iletişimi hızlandıran firmalar ve bağımsız denetim firmalarına aktarılabilmek amaçlarıyla toplanmasına; başta mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre kadar muhafaza edilme ilkesi olmak üzere 6698 Sayılı Kişisel Verilerin Korunması Kanunu’nun (“KVK Kanunu”) 4. maddesinde ifade edilen genel ilkelere uygun şekilde işlenebileceğini; elde edilebileceğini, kaydedilebileceğini, işlenme amacıyla uygun süre zarfında fiziksel veya elektronik ortamda güvenli bir şekilde depolanabileceğini, muhafaza edilebileceğini, değiştirilebileceğini, yeniden düzenlenebileceğini, mevzuata uygun biçimde açıklanabileceğini ve aktarılabileceğini, devralınabileceğini, sınıflandırılabileceğini, işlenebileceğini ya da verilerin kullanılmasının engellenebileceğini; rıza ve onay verdiğim ölçüde kişisel bilgilerimin site ziyaretçileri tarafından erişilebilir olacağını, yukarıda belirtilen hususlarla ilgili olarak bilgilendirildiğimi, KVK Kanunu çerçevesinde <strong>AÇIK RIZAM VE ONAYIMIN bulunduğunu kabul ve beyan ederim.</strong></p>
            <p>İlaveten, KVK Kanunu’nun 11.maddesi ve ilgili mevzuat uyarınca; <i>Par Araştırma ve Danışmanlık Anonim Şirketi tarafından yürütülen “Sensiz olmaz, Sessiz olmaz” Projesi</i> ve Portal’ına  başvurarak kendimle ilgili; kişisel veri işlenip işlenmediğini öğrenme, kişisel verilerim işlenmişse buna ilişkin bilgi talep etme, kişisel verilerimin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme, yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme, kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme, işbu verilerin işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerimin silinmesini veya yok edilmesini isteme, bu düzeltme ve silinme taleplerinin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme, işlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kendi aleyhime bir sonucun ortaya çıkmasına itiraz etme, kişisel verilerimin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme haklarımın olduğunu ve bu hakları kullanmak için kimliğimi tespit edici gerekli bilgiler ile kullanmayı talep ettiğim hakkıma yönelik açıklamaları da içeren talebimi (<a rel="noreferrer" href="https://www.sensizolmazsessizolmaz.org/basvuruformu.pdf" target="_blank" >www.sensizolmazsessizolmaz.org/basvuruformu.pdf</a>) Maslak Mah. Eski Büyükdere Cad. No.37 İçkapı no 8 Sarıyer/İstanbul adresinde bulunan Par Araştırma ve Danışmanlık Anonim Şirketine  kimliğimi tespit edici belgeler ile bizzat elden iletme yahut noter kanalıyla veya KVK Kanunu’nda belirtilen diğer yöntemler ile iletme hakkına sahip olduğumu kabul ediyorum.</p>
            <p>Ayrıca, <i>Par Araştırma ve Danışmanlık Anonim Şirketi tarafından yürütülen “Sensiz olmaz, Sessiz olmaz” Projesi</i> ve Portal’ı ile paylaşmış olduğum kişisel verilerin doğru ve güncel olduğunu; işbu bilgilerde değişiklik olması halinde değişiklikleri bildireceğimi kabul ve beyan ederim.</p>
            <p>KVK Kanunu’nda tanımlanan özel nitelikli kişisel verilerim de dahil olmak üzere ilgili kişisel verilerimin işlenmesine, ilgili süreç kapsamında işlenme amacı ile sınırlı olmak üzere kullanılmasına ve paylaşılmasına, gereken süre zarfında saklanmasına açık rızam olduğunu ve bu hususta tarafıma gerekli aydınlatmanın yapıldığını; işbu metni, Sensiz Olmaz, Sessiz Olmaz projesi kapsamında  Kişisel Verilerin İşlenmesine ilişkin Aydınlatma/Bilgilendirme Metnini okuduğumu ve anladığımı, Veri Sahibi Başvuru Formu hakkında bilgilendirildiğimi ve Kişisel Verilerin Korunması Kanunu Kapsamında <strong>Açık Rıza Onay formunu  kabul ediyorum.</strong></p>
            <p>Kişisel verilerin işlenmesi ve korunmasına ilişkin politikamıza <a rel="noreferrer" href="https://www.sensizolmazsessizolmaz.org/politika.pdf" target="_blank" >www.sensizolmazsessizolmaz.org/politika.pdf</a></p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>              
          </div>
        </div>
      </Popup>
      </section>
      
      
    );
  }
}

const mapStateToProps = state => {
  return {
    step5: state.definitions.step5,
    warningMessage: state.project.warningMessageText,
    warningType: state.project.warningMessageType,
    currentPage: state.project.currentPage,
    showLoading: state.project.showLoading

  }
}

const mapDispatchToProps = dispatch => {
  return {
    onWarning: (payload) => dispatch({ type: ProjectActionTypes.SET_WARNING_MESSAGE, payload: payload}),
    setDefault: () => dispatch({ type: ProjectActionTypes.SET_DEFAULT}),
    setStep5: (step5) => dispatch({ type: DefinitionsActionTypes.SET_STEP5, step5: step5}),
    setCurrent: (value) => dispatch({type: ProjectActionTypes.SET_CURRENT, value: value }),
    setLoading: (showLoading) => dispatch({ type: ProjectActionTypes.SET_LOADING, showLoading: showLoading}),
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Step5));